// SEQ-199: the shared shapes for the grid transformation library.
//
// Every transform is a pure function over plain rows. Nothing here imports
// React, the P&L registry or the word "profit": a transform takes rows, the
// key of the measure to work on, and returns NEW columns keyed by the row id.
// A grid widget composes them; another dashboard can compose them differently.

/** One input row: a stable id plus the numeric measures by key. A null means "no data", never 0. */
export interface TransformRow {
  id: string;
  values: Readonly<Record<string, number | null>>;
}

/** A transform's output: one value per row id, in the order of the input rows. */
export type ColumnResult<T> = Map<string, T>;

/** The numeric value of `key` on a row, or null when it is missing or not a finite number. */
export function measureOf(row: TransformRow, key: string): number | null {
  const value = row.values[key];
  return typeof value === "number" && Number.isFinite(value) ? value : null;
}
